/**
 * Centralized form field IDs for Employee Form
 * Used for accessibility (htmlFor) and testing (data-testid)
 */

export const EMPLOYEE_FORM_IDS = {
  // User data
  ROLE: 'roleUuid',
  PROFILE: 'profileId',
  FIRST_NAME: 'first-name',
  LAST_NAME: 'last-name',

  // Contact data
  EMAIL: 'email',

  // PIN
  PIN: 'posPin',

  // Stores
  ALL_STORES: 'all-stores',
} as const;

export type EmployeeFormFieldId = typeof EMPLOYEE_FORM_IDS[keyof typeof EMPLOYEE_FORM_IDS];
